const resources = {
    giftCardTitle: 'Carte-cadeau',
    free: 'Gratuit',
    giftCardSubtitle: 'Votre carte-cadeau sera expédiée à cette adresse.'
};

export default function getResource(label) {
    return resources[label];
}
